export default __webpack_public_path__ + "static/media/alert_3.b88922d9.png";